import { useI18n } from 'vue-i18n';

// Formats membership level keys (e.g. ['plus', 'pro', 'gold']) as a localized
// disjunction list: "Plus, Pro, or Gold" in English, "Plus, Pro ou Gold" in
// French. Replaces the hand-rolled English serial-comma logic previously
// duplicated across the upgrade components.
export function useMembershipLevels() {
  const { t, locale } = useI18n();

  // Intl.ListFormat is missing on Safari < 14.1 (iOS 14.0, macOS 10.13-10.15
  // on older Safari builds). Fall back to a plain comma + "or" join there.
  const joinDisjunction = (items) => {
    if (typeof Intl.ListFormat === 'function') {
      return new Intl.ListFormat(locale.value, { style: 'long', type: 'disjunction' }).format(items);
    }

    if (items.length === 1) return items[0];
    if (items.length === 2) return `${items[0]} ${t('common.or')} ${items[1]}`;

    return `${items.slice(0, -1).join(', ')}, ${t('common.or')} ${items[items.length - 1]}`;
  };

  // Tolerates a missing/empty list (a member level with no upgrade path,
  // such as Gold) by returning '' instead of throwing.
  const formatMembershipLevels = (levels) => {
    if (!levels?.length) return '';

    return joinDisjunction(levels.map((level) => t(`membership.${level}`)));
  };

  return { formatMembershipLevels };
}
